/**
 * Vite env access isolated in a single module so locale helpers stay free of
 * scattered `import.meta` syntax. `import.meta` is not valid in CommonJS
 * (which is what Jest uses via babel-jest), so this module is replaced with a
 * test stub under Jest via `moduleNameMapper`.
 */
interface LocaleEnv {
  errorPageUrl?: string;
}

export function getLocaleEnv(): LocaleEnv {
  const env = import.meta.env;

  return {
    errorPageUrl: env?.VITE_ERROR_PAGE_URL,
  };
}
